export const EXTENSION_TEXT_KEYS = [
  "brand_eyebrow",
  "flow_heading",
  "flow_subtitle",
  "trigger_label",
  "modal_close",
  "steps_nav_label",
  "steps_step_1",
  "steps_step_2",
  "steps_step_3",
  "steps_step_1_title",
  "steps_step_1_description",
  "steps_step_2_title",
  "steps_step_2_description",
  "steps_step_3_title",
  "steps_step_3_description",
  "actions_next",
  "actions_back",
  "form_first_name",
  "form_last_name",
  "form_email",
  "form_order_number",
  "form_order_number_hint",
  "form_order_label",
  "form_item",
  "form_item_placeholder",
  "form_reason",
  "form_reason_placeholder",
  "form_quantity",
  "form_submit",
  "summary_status_label",
  "summary_status_value",
  "legal_aria_label",
  "legal_title",
  "legal_body",
  "submit_loading",
  "submit_success",
  "submit_error",
  "submit_validation_error"
];
